import React from "react";
import "../style/orthopedic.css";
import Servicessidebar from "../components/servicessidebar";

const treatments = [
    "Minimally invasive biological methods of fixation",
    "Latest fixation devices for simple, complex and complicated fractures",
    "Polytrauma: Single Stage to Multiple Stage Surgeries",
    "Revision of previously failed orthopedic surgeries",
    "Cartilage regeneration and repair",
    "Advanced care for Orthopaedic Infections",
    "Advanced Shoulder & Knee Arthroscopy",
    "All Ligament injuries & Sports injuries"
];

const Orthopedic = () => {
    return (
        <div className="ortho-section">
            <div className="container">
                <div className="ortho-sub-je">
                    <div className="ortho-jp">

                        <h2 className="ortho-title">Orthopaedics</h2>

                        <p className="ortho-description">
                            SAL’s Department of Orthopaedics caters to issues related to the musculo-skeletal system.
                            This includes conditions arising as a result of trauma and various other situations such as arthritis,
                            soft tissue and joint diseases as well as congenital problems. We aim at faster union of fractures
                            and early rehabilitation of patients for Trauma, Arthroplasty and Paediatric Orthopaedics. The
                            department provides excellent care in all major domains of Orthopaedic Surgery.
                        </p>

                        <h3 className="ortho-subtitle">Treatments</h3>

                        <ul className="ortho-list">
                            {treatments.map((item, index) => (
                                <li key={index} className="ortho-item">
                                    <span className={`ortho-icon ${index % 2 === 0 ? "blue" : "green"}`}>
                                        {index % 2 === 0 ? "➤" : "✔"}
                                    </span>
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="ortho-side">
                        <Servicessidebar />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Orthopedic;
